import set_or_update_queryparam from "../custom_js/set_or_update_queryparam.js";

up.compiler(".up_searchcity", function (element) {
  function onChange(event) {
    let new_val = event.target.value;
    const sorter = document.getElementById("sorter");
    let old_link = sorter.getAttribute("href");
    let new_link = set_or_update_queryparam(old_link, "qcity", new_val);
    sorter.setAttribute("href", new_link);

    const qcity_of_qstatus = document.getElementById("qcity_of_qstatus");
    qcity_of_qstatus.value = new_val;
  }
  element.addEventListener("input", onChange);
  return () => {
    element.removeEventListener("input", onChange);
  };
});
